import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";
import OrderDetail from "./OrderDetail";
import OrderModalSkeleton from "../Skeleton/OrderModalSkeleton";
import { GET_INCOMING_ORDER } from "../../graphql/queries/IncomingOrdersContext";

const OrderDetailContainer = ({ supplierOrderId, settings }) => {
  const [orderHistory, setOrderHistory] = useState();

  const { data, loading, error } = useQuery(GET_INCOMING_ORDER, {
    variables: {
      supplierOrderId,
    },
    skip: !supplierOrderId,
  });

  useEffect(() => {
    if (data && data.incomingOrdersContext.details) {
      setOrderHistory(data.incomingOrdersContext.details);
    }
  }, [data]);

  if (loading) {
    return <OrderModalSkeleton />;
  }
  if (error) {
    return "There has been an error";
  }

  return <OrderDetail order={orderHistory} settings={settings} />;
};

OrderDetailContainer.defaultProps = {
  orderId: null,
  orderGroupId: null,
  settings: null,
};

OrderDetailContainer.propTypes = {
  orderId: PropTypes.number,
  orderGroupId: PropTypes.number,
  settings: PropTypes.shape({
    showComment: PropTypes.bool,
    showCostCenter: PropTypes.bool,
    showDeliveryAddress: PropTypes.bool,
    showDeliveryDate: PropTypes.bool,
    showEmail: PropTypes.bool,
    showInvoiceAddress: PropTypes.bool,
    showOrderStatus: PropTypes.bool,
    showPackageColumn: PropTypes.bool,
    showPostalAddress: PropTypes.bool,
    showPriceColumn: PropTypes.bool,
    showProductColumn: PropTypes.bool,
    showQuantityColumn: PropTypes.bool,
    showSummation: PropTypes.bool,
    showWeightColumn: PropTypes.bool,
  }),
};

export default OrderDetailContainer;
